<template>
  <div class="fixed_box">
    <div class="gotop helpbox">
      <div class="kfbox">
        <div class="box">
          <p>电子邮箱：</p>
          <a :href="'mailto:'+(email?email:'service@99api.com')">{{ email ? email : 'service@99api.com' }}</a>
        </div>
        <div class="box">
          <p>联系电话：</p>
          <a>{{ phone ? phone : '19859808442' }}</a>
        </div>
        <div class="Qqbox box">
          <a v-for="(item,index) in customer" :key="index" :href="'tencent://message/?uin='+item" :title="item">
            <img src="@/assets/img/qq_service.png">
            <span>客服{{ index + 1 }}</span>
          </a>
        </div>
        <!--        <div class="qun box" v-if="group.account&&group.account[0]">99API交流群:-->
        <!--          <div :title="group.account[0]">-->
        <!--            <a :href="group.link[0]" target="_blank">{{group.account[0]}}</a>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="qun box" v-if="group.length>0">99API采集助手交流群:
          <div v-for="item in group" :title="item.account">
            <p>
              <a :href="item.link" target="_blank">{{ item.account }}</a>
            </p>
          </div>
        </div>
        <div class="we_service">
          <p>微信客服：</p>
          <img :src="wxCustomer">
        </div>
      </div>
      <!--<div class="gtb">-->
      <!--<i class="el-icon-service"></i>-->
      <!--</div>-->
    </div>
    <el-backtop :visibility-height="0" target=".main_box" :right="50" :bottom="50">
      <div class="gotop" @click="goTop" title="回到顶部"></div>
    </el-backtop>
  </div>
</template>

<script>
import {firm} from '@/config/firm.js'

export default {
  name: "scrollTop",
  data() {
    return {
      showTop: false,
      email: '',
      phone: '',
      customer: [],
      wxCustomer: require('@/assets/img/kefu02.png'),
      group: {},
    }
  },
  mounted() {
    this.getContact();
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getContact() {
      this.email = firm.email;
      this.phone = firm.phone;
      this.customer = firm.contact.customer;
      this.group = firm.contact.group;
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.showTop = scrollTop >= 500;
      // if (scrollTop >= 500) {
      //   this.showTop = true
      // } else {
      //   this.showTop = false
      // }
    },
    goTop() {
      const a = document.createElement('a');
      a.href = '.interface_head'
      let timeInter = setInterval(function () {
        document.documentElement.scrollTop -= document.documentElement.scrollTop / 5;
        if (document.documentElement.scrollTop <= 0) {
          document.documentElement.scrollTop = 0;
          clearInterval(timeInter);
        }
      }, 20);
    }
  }
}
</script>

<style scoped>
.gotop {
  width: 50px;
  height: 50px;
  position: fixed;
  border-radius: 6px;
  /*border: 1px solid rgba(34, 129, 194, 1);*/
  background-color: #7EB3F2;
  font-size: 17px;
  font-weight: 600;
  text-align: center;
  line-height: 32px;
  color: #7EB3F2;
  right: 10px;
  bottom: 150px;
  cursor: pointer;
  background-image: url("../assets/img/gotop.png");
  z-index: 9999;
}

.box {
  margin-bottom: 10px;
}

.helpbox {
  bottom: 210px;
  cursor: inherit;
  background-image: url("../assets/img/kf.png");
}


.helpbox .kfbox {
  width: 300px;
  /*height: 325px;*/
  right: 60px;
  bottom: -15px;
  position: absolute;
  text-align: left;
  /*background-image: url("../static/img/kf_box.png");*/
  background: #fff;
  border: 0.5px solid rgba(108, 118, 125, 1);
  padding: 9px 19px;
  line-height: 19px;
  display: none;
}

.helpbox .kfbox::after {
  content: '';
  border: 10px solid;
  border-color: transparent transparent transparent #000;
  position: absolute;
  right: -20px;
  bottom: 27px;
  z-index: 4;
  /*padding-top: 5px;*/
  /*padding-right: 5px;*/
  /*border: 0.5px solid rgba(108,118,125,1);*/
}

.helpbox .kfbox::before {
  content: '';
  border: 10px solid;
  border-color: transparent transparent transparent #fff;
  position: absolute;
  right: -19px;
  bottom: 27px;
  z-index: 5;
  /*padding-top: 5px;*/
  /*padding-right: 5px;*/
  /*border: 0.5px solid rgba(108,118,125,1);*/
}

.helpbox:hover .kfbox {
  display: block;
}

.helpbox .kfbox p {
  font-size: 14px;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
}

.helpbox .kfbox a {
  font-size: 14px;
  font-weight: 400;
  color: rgba(88, 152, 227, 1);
  text-decoration: none;
  display: inline-block;
}

.helpbox .Qqbox {
  font-size: 14px;
  font-weight: 400;
  color: rgba(176, 176, 176, 1);
  display: flex;
  /*justify-content: space-between;*/
}

.helpbox .Qqbox a {
  display: flex;
  margin-right: 10px;
}

.helpbox .Qqbox span {
  line-height: 26px;
  text-indent: 6px;
}

.helpbox .Qqbox img, .qun img {
  width: 20px;
  height: 23px;
}

.helpbox .kfbox .Qqbox a {
  margin-bottom: 0;
}

.qun {
  font-size: 14px;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  display: flex;
  flex-direction: column;
}

.qun div {
  display: inline-block;
  overflow: hidden;
  line-height: 14px;
}

.qun div a {
  display: inline-block;
  margin: 0;
  /*width: 98px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-indent: 5px;
}

.we_service {
  margin-top: 2px;
}

.we_service img {
  margin-top: 5px;
  width: 115px;
  height: 115px;
}

/*.gotop .gtb{*/
/*width: 32px;*/
/*height: 32px;*/
/*margin-top: 9px;*/
/*margin-left: 9px;*/
/*background: #fff;*/
/*border-radius: 50%;*/
/*}*/
/*.gotop i{*/
/*transform: rotate(90deg);*/
/*}*/

/*.helpbox i{*/
/*transform: none;*/
/*}*/

/*.gotop:hover {*/
/*background: rgba(34, 129, 194, 1);*/
/*color: rgba(34, 129, 194, 1);*/
/*}*/

@media screen and (max-width: 1200px) {
  .gotop {
    display: none;
  }
}
</style>

<style>
.fixed_box .el-backtop {
  position: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/scrollTop.vue